const quota_item = {
    tenant_limit: {
        name: 'تنانت‌ها',
        limited: '{{count, number}} تنانت',
        limited_other: '{{count, number}} تنانت',
        unlimited: 'تنانت‌های نامحدود',
        not_eligible: 'تنانت‌های خود را حذف کنید',
    },
    mau_limit: {
        name: 'کاربران فعال ماهانه',
        limited: '{{count, number}} MAU',
        unlimited: 'MAU نامحدود',
        not_eligible: 'تمام کاربران خود را حذف کنید',
    },
    token_limit: {
        name: 'توکن‌ها',
        limited: '{{count, number}} توکن',
        limited_other: '{{count, number}} توکن',
        unlimited: 'توکن‌های نامحدود',
        not_eligible: 'تمام کاربران خود را حذف کنید تا از ایجاد توکن‌های جدید جلوگیری شود',
    },
    applications_limit: {
        name: 'برنامه‌ها',
        limited: '{{count, number}} برنامه',
        limited_other: '{{count, number}} برنامه',
        unlimited: 'برنامه‌های نامحدود',
        not_eligible: 'برنامه‌های خود را حذف کنید',
    },
    machine_to_machine_limit: {
        name: 'ماشین به ماشین',
        limited: '{{count, number}} اپلیکیشن ماشین به ماشین',
        limited_other: '{{count, number}} اپلیکیشن ماشین به ماشین',
        unlimited: 'اپلیکیشن‌های ماشین به ماشین نامحدود',
        not_eligible: 'اپلیکیشن‌های ماشین به ماشین خود را حذف کنید',
    },
    third_party_applications_limit: {
        name: 'اپلیکیشن‌های شخص ثالث',
        limited: '{{count, number}} اپلیکیشن شخص ثالث',
        limited_other: '{{count, number}} اپلیکیشن شخص ثالث',
        unlimited: 'اپلیکیشن‌های شخص ثالث نامحدود',
        not_eligible: 'اپلیکیشن‌های شخص ثالث خود را حذف کنید',
    },
    resources_limit: {
        name: 'منابع API',
        limited: '{{count, number}} منبع API',
        limited_other: '{{count, number}} منبع API',
        unlimited: 'منابع API نامحدود',
        not_eligible: 'منابع API خود را حذف کنید',
    },
    scopes_per_resource_limit: {
        name: 'مجوزهای منبع',
        limited: '{{count, number}} مجوز در هر منبع',
        limited_other: '{{count, number}} مجوز در هر منبع',
        unlimited: 'مجوزهای نامحدود در هر منبع',
        not_eligible: 'مجوزهای منبع خود را حذف کنید',
    },
    custom_domain_enabled: {
        name: 'دامنه سفارشی',
        limited: 'دامنه سفارشی',
        unlimited: 'دامنه سفارشی',
        not_eligible: 'دامنه سفارشی خود را حذف کنید',
    },
    omni_sign_in_enabled: {
        name: 'ورود همه‌جانبه',
        limited: 'ورود همه‌جانبه',
        unlimited: 'ورود همه‌جانبه',
        not_eligible: 'ورود همه‌جانبه خود را غیرفعال کنید',
    },
    built_in_email_connector_enabled: {
        name: 'اتصال‌دهنده ایمیل داخلی',
        limited: 'اتصال‌دهنده ایمیل داخلی',
        unlimited: 'اتصال‌دهنده ایمیل داخلی',
        not_eligible: 'اتصال‌دهنده ایمیل داخلی خود را حذف کنید',
    },
    social_connectors_limit: {
        name: 'اتصال‌دهنده‌های اجتماعی',
        limited: '{{count, number}} اتصال‌دهنده اجتماعی',
        limited_other: '{{count, number}} اتصال‌دهنده اجتماعی',
        unlimited: 'اتصال‌دهنده‌های اجتماعی نامحدود',
        not_eligible: 'اتصال‌دهنده‌های اجتماعی خود را حذف کنید',
    },
    standard_connectors_limit: {
        name: 'اتصال‌دهنده‌های استاندارد رایگان',
        limited: '{{count, number}} اتصال‌دهنده استاندارد رایگان',
        limited_other: '{{count, number}} اتصال‌دهنده استاندارد رایگان',
        unlimited: 'اتصال‌دهنده‌های استاندارد نامحدود',
        not_eligible: 'اتصال‌دهنده‌های استاندارد خود را حذف کنید',
    },
    roles_limit: {
        name: 'نقش‌ها',
        limited: '{{count, number}} نقش',
        limited_other: '{{count, number}} نقش',
        unlimited: 'نقش‌های نامحدود',
        not_eligible: 'نقش‌های خود را حذف کنید',
    },
    machine_to_machine_roles_limit: {
        name: 'نقش‌های ماشین به ماشین',
        limited: '{{count, number}} نقش ماشین به ماشین',
        limited_other: '{{count, number}} نقش ماشین به ماشین',
        unlimited: 'نقش‌های ماشین به ماشین نامحدود',
        not_eligible: 'نقش‌های ماشین به ماشین خود را حذف کنید',
    },
    scopes_per_role_limit: {
        name: 'مجوزهای نقش',
        limited: '{{count, number}} مجوز در هر نقش',
        limited_other: '{{count, number}} مجوز در هر نقش',
        unlimited: 'مجوزهای نامحدود در هر نقش',
        not_eligible: 'مجوزهای نقش خود را حذف کنید',
    },
    hooks_limit: {
        name: 'وب‌هوک‌ها',
        limited: '{{count, number}} وب‌هوک',
        limited_other: '{{count, number}} وب‌هوک',
        unlimited: 'وب‌هوک‌های نامحدود',
        not_eligible: 'وب‌هوک‌های خود را حذف کنید',
    },
    organizations_enabled: {
        name: 'سازمان‌ها',
        limited: 'سازمان‌ها',
        unlimited: 'سازمان‌ها',
        not_eligible: 'سازمان‌های خود را حذف کنید',
    },
    audit_logs_retention_days: {
        name: 'نگهداری گزارش‌های ممیزی',
        limited: 'نگهداری گزارش‌های ممیزی: {{count, number}} روز',
        limited_other: 'نگهداری گزارش‌های ممیزی: {{count, number}} روز',
        unlimited: 'روزهای نامحدود',
        not_eligible: 'بدون گزارش ممیزی',
    },
    email_ticket_support: {
        name: 'پشتیبانی تیکت ایمیلی',
        limited: 'پشتیبانی تیکت ایمیلی {{count, number}} ساعته',
        limited_other: 'پشتیبانی تیکت ایمیلی {{count, number}} ساعته',
        unlimited: 'پشتیبانی تیکت ایمیلی',
        not_eligible: 'بدون پشتیبانی تیکت ایمیلی',
    },
    mfa_enabled: {
        name: 'احراز هویت چندعاملی',
        limited: 'احراز هویت چندعاملی',
        unlimited: 'احراز هویت چندعاملی',
        not_eligible: 'احراز هویت چندعاملی خود را حذف کنید',
    },
    sso_enabled: {
        name: 'SSO سازمانی',
        limited: 'SSO سازمانی',
        unlimited: 'SSO سازمانی',
        not_eligible: 'SSO سازمانی خود را حذف کنید',
    },
    tenant_members_limit: {
        name: 'اعضای تنانت',
        limited: '{{count, number}} عضو تنانت',
        limited_other: '{{count, number}} عضو تنانت',
        unlimited: 'اعضای تنانت نامحدود',
        not_eligible: 'اعضای تنانت خود را حذف کنید',
    },
    custom_jwt_enabled: {
        name: 'JWT سفارشی',
        limited: 'JWT سفارشی',
        unlimited: 'JWT سفارشی',
        not_eligible: 'سفارشی‌ساز ادعاهای JWT خود را حذف کنید',
    },
    impersonation_enabled: {
        name: 'جعل هویت',
        limited: 'جعل هویت',
        unlimited: 'جعل هویت',
        not_eligible: 'جعل هویت مجاز نیست',
    },
    bring_your_ui_enabled: {
        name: 'رابط کاربری سفارشی',
        limited: 'رابط کاربری سفارشی',
        unlimited: 'رابط کاربری سفارشی',
        not_eligible: 'فایل‌های رابط کاربری سفارشی خود را حذف کنید',
    },
    collect_user_profile_enabled: {
        name: 'جمع‌آوری پروفایل کاربر',
        limited: 'جمع‌آوری پروفایل کاربر',
        unlimited: 'جمع‌آوری پروفایل کاربر',
        not_eligible: 'فیلدهای جمع‌آوری پروفایل کاربر خود را حذف کنید',
    },
    idp_initiated_sso_enabled: {
        name: 'SSO آغازشده توسط IDP',
        limited: 'SSO آغازشده توسط IDP',
        unlimited: 'SSO آغازشده توسط IDP',
        not_eligible: 'SSO آغازشده توسط IDP مجاز نیست',
    },
    saml_applications_limit: {
        name: 'برنامه‌های SAML',
        limited: '{{count, number}} برنامه SAML',
        limited_other: '{{count, number}} برنامه SAML',
        unlimited: 'برنامه‌های SAML نامحدود',
        not_eligible: 'برنامه‌های SAML خود را حذف کنید',
    },
    captcha_enabled: {
        name: 'CAPTCHA',
        limited: 'CAPTCHA',
        unlimited: 'CAPTCHA',
        not_eligible: 'CAPTCHA خود را حذف کنید',
    },
    security_features_enabled: {
        name: 'امنیت پیشرفته',
        limited: 'امنیت پیشرفته',
        unlimited: 'امنیت پیشرفته',
        not_eligible: 'تنظیمات امنیت پیشرفته خود را حذف کنید',
    },
    custom_domains_limit: {
        name: 'دامنه‌های سفارشی',
        limited: '{{count, number}} دامنه سفارشی',
        limited_other: '{{count, number}} دامنه سفارشی',
        unlimited: 'دامنه‌های سفارشی نامحدود',
        not_eligible: 'دامنه‌های سفارشی خود را حذف کنید',
    },
    passkey_sign_in_enabled: {
        name: 'ورود با کلید عبور',
        limited: 'ورود با کلید عبور',
        unlimited: 'ورود با کلید عبور',
        not_eligible: 'پشتیبانی از ورود با کلید عبور وجود ندارد',
    },
};
export default Object.freeze(quota_item);
